module.exports = __webpack_public_path__ + "img/38-girl.5e409d64.svg";